import React, { useState } from 'react';

import Tabs from './tabs';
import Stages from './stages';
import View from './view';

import './styles.scss';

export default function PipelineSettings() {
  const [activeTab, setActiveTab] = useState('stages');

  return (
    <div className="pipeline-settings">
      {<Tabs activeTab={activeTab} setActiveTab={setActiveTab} />}
      {activeTab === 'stages' && <Stages />}
      {activeTab === 'view' && <View />}
    </div>
  );
}
